// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #592727 RED */
/* #2f5927 GREEN */
/* #30426a BLUE (default)*/
/* Sidebar background color */
/* Sidebar header and footer color */
/* Sidebar title text colour */
/* Sidebar menu item hover color */
`, "",{"version":3,"sources":["webpack://./layout/resources/less/variables.less"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,kBAAkB;AAClB,0BAA0B;AAC1B,6BAA6B;AAC7B,oCAAoC;AACpC,8BAA8B;AAC9B,kCAAkC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
